(function () {
  'use strict';

  var PDP_EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var PDP_MS = 220;

  function formatMoney(cents) {
    var amount = Number(cents);
    if (isNaN(amount)) amount = 0;
    var moneyFormat = (window.EV_CONFIG && window.EV_CONFIG.moneyFormat) || '${{amount}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount, moneyFormat);
    }
    var dollars = (Math.round(amount) / 100).toFixed(2);
    return moneyFormat.indexOf('{{amount}}') !== -1
      ? moneyFormat.replace('{{amount}}', dollars)
      : '$' + dollars;
  }

  function createBundleId() {
    return 'evb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function parseEligibleWallets(selector) {
    var script = selector.querySelector('[data-ev-eligible-wallets]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (error) {
      console.error('[EliteVault PDP] eligible wallets JSON parse failed:', error);
      return [];
    }
  }

  function findVariantInCatalog(catalog, variantId) {
    var id = parseInt(variantId, 10);
    for (var i = 0; i < catalog.length; i++) {
      var product = catalog[i];
      var variants = product.variants || [];
      for (var j = 0; j < variants.length; j++) {
        if (parseInt(variants[j].id, 10) === id) {
          return { product: product, variant: variants[j] };
        }
      }
    }
    return null;
  }

  function calcSetPricing(priceCentsList, percent) {
    var subtotal = 0;
    (priceCentsList || []).forEach(function (cents) {
      subtotal += parseInt(cents, 10) || 0;
    });
    var pct = parseInt(percent, 10) || 0;
    var discount = Math.round(subtotal * pct / 100);
    return {
      regularTotalCents: subtotal,
      discountCents: discount,
      discountedTotalCents: Math.max(0, subtotal - discount),
      percent: pct
    };
  }

  function calcSecondWalletDiscount(secondPriceCents, percent) {
    var unit = parseInt(secondPriceCents, 10) || 0;
    var pct = parseInt(percent, 10);
    if (isNaN(pct)) pct = 15;
    return Math.round(unit * pct / 100);
  }

  function parseVariants(root) {
    var script = root.querySelector('[data-ev-product-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('[EliteVault PDP] variant JSON parse failed:', error);
      return [];
    }
  }

  function getActiveSlideImage(gallery) {
    var active = gallery.querySelector('[data-ev-gallery-slide].is-active img.ev-pdp-gallery__image');
    return active || gallery.querySelector('[data-ev-gallery-slide]:not([hidden]) img.ev-pdp-gallery__image');
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-ev-pdp-gallery]');
    if (!gallery || gallery.dataset.evGalleryBound === 'true') return;
    gallery.dataset.evGalleryBound = 'true';

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-ev-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ev-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-ev-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-ev-gallery-next]');
    var viewport = gallery.querySelector('[data-ev-gallery-viewport]');
    var expandBtn = gallery.querySelector('[data-ev-gallery-expand]');
    var lightbox = gallery.querySelector('[data-ev-lightbox]');
    var lightboxImage = gallery.querySelector('[data-ev-lightbox-image]');
    var lightboxClose = gallery.querySelector('[data-ev-lightbox-close]');
    var lightboxPrev = gallery.querySelector('[data-ev-lightbox-prev]');
    var lightboxNext = gallery.querySelector('[data-ev-lightbox-next]');
    var activeIndex = 0;
    var initialSlide = gallery.querySelector('[data-ev-gallery-slide].is-active');
    if (initialSlide) {
      activeIndex = parseInt(initialSlide.dataset.mediaIndex, 10) || 0;
    }

    function showSlide(index) {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        var isActive = i === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;

        if (!isActive) {
          var video = slide.querySelector('video');
          if (video) video.pause();
        }
      });

      thumbs.forEach(function (thumb) {
        var thumbIndex = parseInt(thumb.dataset.mediaIndex, 10);
        var isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (lightbox && !lightbox.hidden && lightboxImage) {
        var img = slides[activeIndex] ? slides[activeIndex].querySelector('img.ev-pdp-gallery__image') : null;
        if (img) {
          lightboxImage.src = img.currentSrc || img.src;
          lightboxImage.alt = img.alt || '';
        }
      }
    }

    function openLightbox() {
      if (!lightbox || !lightboxImage) return;
      var img = getActiveSlideImage(gallery);
      if (!img) return;
      lightboxImage.src = img.currentSrc || img.src;
      lightboxImage.alt = img.alt || '';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ev-pdp-lightbox-open');
      if (lightboxClose) lightboxClose.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ev-pdp-lightbox-open');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(parseInt(thumb.dataset.mediaIndex, 10) || 0);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(activeIndex + 1); });
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { showSlide(activeIndex + 1); });
    if (expandBtn) expandBtn.addEventListener('click', openLightbox);
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    if (viewport && slides.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;

      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showSlide(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showSlide(activeIndex + 1);
        }
      });

      viewport.addEventListener('touchstart', function (event) {
        var touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      viewport.addEventListener('touchend', function (event) {
        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaY) > Math.abs(deltaX)) return;
        if (deltaX < 0) showSlide(activeIndex + 1);
        else showSlide(activeIndex - 1);
      }, { passive: true });

      viewport.addEventListener('dblclick', openLightbox);
    }

    gallery.showMediaById = function (mediaId) {
      if (!mediaId) return;
      var targetIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId) === String(mediaId);
      });
      if (targetIndex >= 0) showSlide(targetIndex);
    };
  }

  function initZoom(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    root.querySelectorAll('[data-ev-gallery-zoom]').forEach(function (zoomWrap) {
      if (zoomWrap.dataset.evZoomBound === 'true') return;
      zoomWrap.dataset.evZoomBound = 'true';

      var image = zoomWrap.querySelector('img');
      if (!image) return;

      zoomWrap.addEventListener('mousemove', function (event) {
        var rect = zoomWrap.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        image.style.transformOrigin = x + '% ' + y + '%';
        image.style.transform = 'scale(1.75)';
      });

      zoomWrap.addEventListener('mouseleave', function () {
        image.style.transform = '';
        image.style.transformOrigin = '';
      });
    });
  }

  function initVariantPicker(root, variants) {
    var form = root.querySelector('[data-ev-pdp-form]');
    if (!form || !variants.length) return;

    var idInput = form.querySelector('[data-ev-variant-id]');
    var priceCurrent = root.querySelector('[data-ev-price-current]');
    var priceCompare = root.querySelector('[data-ev-price-compare]');
    var priceBadge = root.querySelector('[data-ev-price-badge]');
    var atcBtn = root.querySelector('[data-ev-pdp-atc]');
    var stickyAtc = root.querySelector('[data-ev-sticky-atc]');
    var stickyPrice = root.querySelector('[data-ev-sticky-price]');
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-ev-option]'));
    var gallery = root.querySelector('[data-ev-pdp-gallery]');

    function getSelectedOptions() {
      return optionGroups.map(function (group) {
        var selected = group.querySelector('.ev-pdp-option__value.is-selected');
        if (selected && selected.dataset.evOptionValue) {
          return selected.dataset.evOptionValue;
        }
        var fixed = group.getAttribute('data-ev-option-fixed-value');
        return fixed || null;
      });
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return optionValue === selected[index];
        });
      });
    }

    function updateOptionUI() {
      optionGroups.forEach(function (group) {
        var position = parseInt(group.dataset.optionPosition, 10);
        var selectedBtn = group.querySelector('.ev-pdp-option__value.is-selected');
        var selectedLabel = group.querySelector('[data-ev-option-selected]');
        if (selectedLabel && selectedBtn) {
          selectedLabel.textContent = selectedBtn.dataset.evOptionValue;
        }

        group.querySelectorAll('[data-ev-option-value]').forEach(function (btn) {
          var trial = getSelectedOptions().slice();
          trial[position - 1] = btn.dataset.evOptionValue;
          var exists = variants.some(function (variant) {
            return variant.options.every(function (value, index) {
              return value === trial[index];
            });
          });
          var available = variants.some(function (variant) {
            return variant.available && variant.options.every(function (value, index) {
              return value === trial[index];
            });
          });
          btn.disabled = !exists;
          btn.classList.toggle('is-unavailable', exists && !available);
          btn.setAttribute('aria-checked', btn.classList.contains('is-selected') ? 'true' : 'false');
        });
      });
    }

    function updateVariantState(variant) {
      if (!variant || !idInput) return;

      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);

      var stickyPriceCurrent = root.querySelector('[data-ev-sticky-price-current]');
      var stickyPriceCompare = root.querySelector('[data-ev-sticky-price-compare]');
      if (stickyPriceCurrent) stickyPriceCurrent.textContent = formatMoney(variant.price);
      else if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (priceCompare && priceBadge) {
        if (variant.compare_at_price > variant.price) {
          var savings = variant.compare_at_price - variant.price;
          var percent = Math.round((savings / variant.compare_at_price) * 100);
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
          priceBadge.textContent = 'SAVE ' + percent + '%';
          priceBadge.hidden = false;
          if (stickyPriceCompare) {
            stickyPriceCompare.textContent = formatMoney(variant.compare_at_price);
            stickyPriceCompare.hidden = false;
          }
        } else {
          priceCompare.hidden = true;
          priceBadge.hidden = true;
          if (stickyPriceCompare) stickyPriceCompare.hidden = true;
        }
      }

      var label = variant.available ? (atcBtn && atcBtn.dataset.availableLabel) || 'Add to Cart' : (atcBtn && atcBtn.dataset.soldOutLabel) || 'Sold Out';
      if (atcBtn) {
        atcBtn.textContent = label;
        atcBtn.disabled = !variant.available;
        atcBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      }
      if (stickyAtc) {
        stickyAtc.textContent = label;
        stickyAtc.disabled = !variant.available;
      }

      if (gallery && typeof gallery.showMediaById === 'function' && variant.featured_media) {
        gallery.showMediaById(variant.featured_media);
      }

      root.dispatchEvent(new CustomEvent('ev:variant:change', {
        detail: { variant: variant }
      }));

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (atcBtn) {
      atcBtn.dataset.availableLabel = atcBtn.textContent.trim();
      atcBtn.dataset.soldOutLabel = 'Sold Out';
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('[data-ev-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          group.querySelectorAll('[data-ev-option-value]').forEach(function (peer) {
            peer.classList.remove('is-selected');
            peer.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
          updateOptionUI();
          updateVariantState(findVariant());
        });
      });
    });

    updateOptionUI();
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-ev-qty]');
    if (!input) return;

    var minus = root.querySelector('[data-ev-qty-minus]');
    var plus = root.querySelector('[data-ev-qty-plus]');

    function clamp(value) {
      var min = parseInt(input.min, 10) || 1;
      return Math.max(min, value);
    }

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) + 1);
      });
    }
  }

  function initBundleSelector(root) {
    var selector = root.querySelector('[data-ev-bundle-selector]');
    var qtyInput = root.querySelector('[data-ev-qty]');
    if (!selector || !qtyInput || selector.dataset.evBundleBound === 'true') return;
    selector.dataset.evBundleBound = 'true';

    var options = Array.prototype.slice.call(selector.querySelectorAll('[data-ev-bundle-option]'));
    var liveRegion = selector.querySelector('[data-ev-bundle-live]');
    var mixMatchBtn = selector.querySelector('[data-ev-bundle-mix-match]');
    var giftPct = parseInt(selector.dataset.giftPct, 10);
    var executivePct = parseInt(selector.dataset.executivePct, 10);
    /* Messaging % comes from Theme settings via Liquid data attributes — never invent tiers. */

    function announce(message) {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      window.requestAnimationFrame(function () {
        liveRegion.textContent = message || '';
      });
    }

    function currentUnitPrice() {
      return parseInt(selector.dataset.unitPrice, 10) || 0;
    }

    function currentCompareAt() {
      return parseInt(selector.dataset.unitCompare, 10) || 0;
    }

    function discountedTotal(unitCents, qty, pct) {
      var regular = (parseInt(unitCents, 10) || 0) * (parseInt(qty, 10) || 1);
      var discount = Math.round(regular * (parseInt(pct, 10) || 0) / 100);
      return {
        regular: regular,
        discount: discount,
        total: Math.max(0, regular - discount)
      };
    }

    function updateOptionTotals() {
      options.forEach(function (option) {
        var key = option.dataset.bundleKey || 'individual';
        var priceEl = option.querySelector('[data-ev-bundle-price]');
        var compareEl = option.querySelector('[data-ev-bundle-compare]');
        var saveEl = option.querySelector('[data-ev-bundle-save]');
        var unit = currentUnitPrice();
        var unitCompare = currentCompareAt();

        if (key === 'individual') {
          if (priceEl) priceEl.textContent = formatMoney(unit);
          if (compareEl) {
            if (unitCompare > unit) {
              compareEl.textContent = formatMoney(unitCompare);
              compareEl.hidden = false;
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.textContent = '';
              compareEl.hidden = true;
              compareEl.setAttribute('hidden', '');
            }
          }
          return;
        }

        /* Gift / Executive: messaging % from Theme settings (data attributes). */
        var pct = key === 'gift' ? giftPct : executivePct;
        if (saveEl) {
          if (!isNaN(pct) && pct > 0) {
            saveEl.textContent = 'SAVE ' + pct + '%';
            saveEl.hidden = false;
            saveEl.removeAttribute('hidden');
          } else {
            saveEl.textContent = '';
            saveEl.hidden = true;
            saveEl.setAttribute('hidden', '');
          }
        }
      });
    }

    function pulseBundleSave(option) {
      var key = option.dataset.bundleKey || '';
      if (key !== 'gift' && key !== 'executive') return;
      var saveEl = option.querySelector('[data-ev-bundle-save]');
      if (!saveEl) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        saveEl.classList.remove('is-pulsing');
        return;
      }
      saveEl.classList.remove('is-pulsing');
      void saveEl.offsetWidth;
      saveEl.classList.add('is-pulsing');
    }

    function selectOption(option) {
      var key = option.dataset.bundleKey || 'individual';
      var slots = parseInt(option.dataset.slots, 10) || 1;
      qtyInput.value = String(slots);
      selector.dataset.selectedBundle = key;
      selector.dataset.selectedBundleName = option.dataset.bundleName || key;
      selector.dataset.selectedSlots = String(slots);

      options.forEach(function (item) {
        var isActive = item === option;
        item.classList.toggle('is-selected', isActive);
        var radio = item.querySelector('[data-ev-bundle-radio]');
        if (radio) {
          radio.checked = isActive;
          radio.setAttribute('aria-checked', isActive ? 'true' : 'false');
        }
      });

      updateOptionTotals();
      pulseBundleSave(option);
      var titleEl = option.querySelector('.ev-bundle-option__title');
      announce((titleEl ? titleEl.textContent.trim() : 'Set') + ' selected.');
    }

    function getPdpImage() {
      var img = root.querySelector('[data-ev-gallery-slide].is-active img, .ev-pdp-gallery__image');
      return img ? img.currentSrc || img.src : '';
    }

    function getSelectedVariantAvailable() {
      var variants = parseVariants(root);
      var variantInput = root.querySelector('[data-ev-variant-id]');
      var variantId = parseInt((variantInput && variantInput.value) || selector.dataset.currentVariantId, 10);
      if (!variantId) return false;
      for (var i = 0; i < variants.length; i++) {
        if (parseInt(variants[i].id, 10) === variantId) {
          return !!variants[i].available;
        }
      }
      return selector.dataset.currentVariantAvailable !== 'false';
    }

    selector.getBuildContext = function () {
      var variantInput = root.querySelector('[data-ev-variant-id]');
      var variantId = parseInt((variantInput && variantInput.value) || selector.dataset.currentVariantId, 10);
      var price = currentUnitPrice();
      var compare = currentCompareAt();
      var slots = parseInt(selector.dataset.selectedSlots, 10) || 1;
      var key = selector.dataset.selectedBundle || 'individual';
      var pct = key === 'gift' ? giftPct : key === 'executive' ? executivePct : 0;
      var priced = key === 'individual'
        ? { regular: price, discount: 0, total: price }
        : discountedTotal(price, slots, pct);
      return {
        variantId: variantId,
        productId: parseInt(selector.dataset.productId, 10) || 0,
        productTitle: selector.dataset.productTitle || '',
        variantTitle: selector.dataset.currentVariantTitle || '',
        price: price,
        compareAt: compare > price ? compare : null,
        image: getPdpImage(),
        quantity: slots,
        bundleKey: key,
        bundleName: selector.dataset.selectedBundleName || key,
        displayedTotal: priced.total,
        displayedRegular: priced.regular,
        discountPercent: pct,
        available: getSelectedVariantAvailable()
      };
    };

    options.forEach(function (option) {
      var radio = option.querySelector('[data-ev-bundle-radio]');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked) selectOption(option);
      });
      option.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          radio.checked = true;
          selectOption(option);
        }
      });
    });

    if (mixMatchBtn) {
      mixMatchBtn.addEventListener('click', function () {
        var buildContext = selector.getBuildContext();
        if (!buildContext.variantId) return;
        var mixMode = buildContext.bundleKey === 'executive' ? 'executive' : 'gift';
        document.dispatchEvent(new CustomEvent('ev:set:build', {
          detail: {
            mode: mixMode,
            buildContext: buildContext,
            source: 'mix-and-match'
          }
        }));
      });
    }

    var initiallySelected =
      selector.querySelector('[data-ev-bundle-option][data-bundle-key="gift"]') ||
      selector.querySelector('[data-ev-bundle-option].is-selected') ||
      options[0];
    if (initiallySelected) selectOption(initiallySelected);
    else updateOptionTotals();

    root.addEventListener('ev:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && typeof variant.price === 'number') {
        selector.dataset.unitPrice = String(variant.price);
        selector.dataset.unitCompare = String(variant.compare_at_price || 0);
        if (variant.id) selector.dataset.currentVariantId = String(variant.id);
        if (variant.title) selector.dataset.currentVariantTitle = variant.title;
        selector.dataset.currentVariantAvailable = variant.available ? 'true' : 'false';
        updateOptionTotals();
      }
    });
  }

  function initPdpForm(root) {
    var form = root.querySelector('[data-ev-pdp-form]');
    if (!form || form.dataset.evFormBound === 'true') return;
    form.dataset.evFormBound = 'true';
    var submitting = false;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitting) return;

      var atc = form.querySelector('[data-ev-pdp-atc]');
      if (atc && (atc.disabled || atc.getAttribute('aria-disabled') === 'true')) return;

      var selector = root.querySelector('[data-ev-bundle-selector]');
      var variantInput = form.querySelector('[data-ev-variant-id]');
      var qtyInput = form.querySelector('[data-ev-qty]');
      var errEl = form.querySelector('[data-ev-pdp-error]');
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }

      var buildContext = selector && typeof selector.getBuildContext === 'function'
        ? selector.getBuildContext()
        : null;
      var bundleKey = (buildContext && buildContext.bundleKey) ||
        (selector && selector.dataset.selectedBundle) ||
        'individual';
      var variantId = parseInt(
        (buildContext && buildContext.variantId) ||
        (variantInput && variantInput.value),
        10
      );
      var quantity = 1;
      if (bundleKey === 'individual') quantity = 1;

      if (!variantId) {
        if (errEl) {
          errEl.textContent = 'Select an available variant first.';
          errEl.hidden = false;
        }
        return;
      }

      if (buildContext && buildContext.available === false) {
        if (errEl) {
          errEl.textContent = 'This option is sold out.';
          errEl.hidden = false;
        }
        return;
      }

      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        (window.EV_CONFIG && window.EV_CONFIG.currency) ||
        '';

      /* Gift / Executive: open wallet builder with PDP as Wallet 1 — do not add identical qty */
      if (bundleKey === 'gift' || bundleKey === 'executive') {
        if (!buildContext) {
          if (errEl) {
            errEl.textContent = 'Could not start set builder. Please try again.';
            errEl.hidden = false;
          }
          return;
        }
        document.dispatchEvent(new CustomEvent('ev:bundle:add', {
          detail: {
            offer: bundleKey,
            offerName: buildContext.bundleName || bundleKey,
            productId: buildContext.productId || 0,
            variantId: variantId,
            quantity: buildContext.quantity || (bundleKey === 'gift' ? 2 : 3),
            deferred: true,
            displayedTotal: buildContext.displayedTotal,
            currency: currency
          }
        }));
        document.dispatchEvent(new CustomEvent('ev:set:build', {
          detail: {
            mode: bundleKey,
            buildContext: buildContext,
            source: 'pdp-atc'
          }
        }));
        return;
      }

      /* Individual: open deferred upsell drawer — do not add until footer action */
      if (bundleKey === 'individual') {
        if (!buildContext) {
          if (errEl) {
            errEl.textContent = 'Could not open wallet drawer. Please try again.';
            errEl.hidden = false;
          }
          return;
        }
        document.dispatchEvent(new CustomEvent('ev:bundle:add', {
          detail: {
            offer: 'individual',
            offerName: buildContext.bundleName || 'Individual',
            productId: buildContext.productId || 0,
            variantId: variantId,
            quantity: 1,
            deferred: true,
            displayedTotal: buildContext.displayedTotal,
            currency: currency
          }
        }));
        document.dispatchEvent(new CustomEvent('ev:set:build', {
          detail: {
            mode: 'individual',
            buildContext: buildContext,
            source: 'pdp-atc'
          }
        }));
        return;
      }

      var addOneFn = window.EV && window.EV.addVariantToCart;
      if (!addOneFn) return;

      submitting = true;
      if (atc) {
        atc.disabled = true;
        atc.setAttribute('aria-busy', 'true');
      }

      document.dispatchEvent(new CustomEvent('ev:bundle:add', {
        detail: {
          offer: bundleKey,
          offerName: (buildContext && buildContext.bundleName) || bundleKey,
          productId: (buildContext && buildContext.productId) || 0,
          variantId: variantId,
          quantity: quantity,
          displayedTotal: buildContext && buildContext.displayedTotal,
          currency: currency
        }
      }));

      var confirmMeta = {
        mode: 'confirm',
        offer: bundleKey,
        offerName: (buildContext && buildContext.bundleName) || bundleKey,
        productId: (buildContext && buildContext.productId) || 0,
        productName: (buildContext && buildContext.productTitle) || '',
        variantId: variantId,
        variantTitle: (buildContext && buildContext.variantTitle) || '',
        quantity: quantity,
        unitPrice: (buildContext && buildContext.price) || 0,
        compareAt: (buildContext && buildContext.compareAt) || 0,
        displayedTotal: buildContext && buildContext.displayedTotal,
        displayedRegular: buildContext && buildContext.displayedRegular,
        discountPercent: (buildContext && buildContext.discountPercent) || 0,
        image: (buildContext && buildContext.image) || '',
        currency: currency
      };

      addOneFn(variantId, quantity)
        .then(function (data) {
          if (window.EV && typeof window.EV.handleCartAddSuccess === 'function') {
            window.EV.handleCartAddSuccess(data, confirmMeta);
          }
          document.dispatchEvent(new CustomEvent('ev:bundle:added', {
            detail: Object.assign({ item: data }, confirmMeta)
          }));
        })
        .catch(function (error) {
          console.error('[EliteVault PDP] add to cart failed:', error);
          var raw = (error && error.message) || '';
          var msg;
          if (/sold out|unavailable|inventory|stock/i.test(raw)) {
            msg = 'This option is currently unavailable.';
          } else {
            msg = 'Could not add to cart. Please try again.';
          }
          if (errEl) {
            errEl.textContent = msg;
            errEl.hidden = false;
          }
          if (selector) {
            var liveRegion = selector.querySelector('[data-ev-bundle-live]');
            if (liveRegion) {
              liveRegion.textContent = '';
              window.requestAnimationFrame(function () {
                liveRegion.textContent = msg;
              });
            }
          }
        })
        .finally(function () {
          submitting = false;
          if (atc && !atc.hasAttribute('data-ev-sold-out') && atc.getAttribute('aria-disabled') !== 'true') {
            atc.disabled = false;
            atc.removeAttribute('aria-busy');
          }
        });
    });
  }

  function initStickyBar(root) {
    var sticky = root.querySelector('[data-ev-pdp-sticky]');
    var actions = root.querySelector('[data-ev-pdp-actions]');
    var stickyAtc = root.querySelector('[data-ev-sticky-atc]');
    var form = root.querySelector('[data-ev-pdp-form]');
    var mainAtc = root.querySelector('[data-ev-pdp-atc]');

    if (!sticky || !actions) return;

    var isMobile = window.matchMedia('(max-width: 1023px)').matches;
    var visible = false;

    function setStickyState(show) {
      if (show === visible) return;
      visible = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.documentElement.classList.toggle('ev-pdp-sticky-active', show);
    }

    function onScroll() {
      var rect = actions.getBoundingClientRect();
      if (isMobile) {
        setStickyState(window.scrollY > 120);
      } else {
        setStickyState(rect.bottom < 0);
      }
    }

    if (stickyAtc && form && mainAtc) {
      stickyAtc.addEventListener('click', function () {
        if (stickyAtc.disabled) return;
        mainAtc.click();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      isMobile = window.matchMedia('(max-width: 1023px)').matches;
      onScroll();
    }, { passive: true });
    onScroll();
  }

  function resetProductBindings(root) {
    if (!root) return;
    delete root.dataset.evProductBound;
    var selector = root.querySelector('[data-ev-bundle-selector]');
    if (selector) delete selector.dataset.evBundleBound;
    var form = root.querySelector('[data-ev-pdp-form]');
    if (form) delete form.dataset.evFormBound;
    var gallery = root.querySelector('[data-ev-pdp-gallery]');
    if (gallery) delete gallery.dataset.evGalleryBound;
    root.querySelectorAll('[data-ev-gallery-zoom]').forEach(function (el) {
      delete el.dataset.evZoomBound;
    });
  }

  function initProductPage(root) {
    if (!root || root.dataset.evProductBound === 'true') return;
    root.dataset.evProductBound = 'true';

    var variants = parseVariants(root);
    initGallery(root);
    initZoom(root);
    initVariantPicker(root, variants);
    initQuantity(root);
    initBundleSelector(root);
    initPdpForm(root);
    initStickyBar(root);
  }

  function initAll() {
    document.querySelectorAll('[data-ev-product]').forEach(initProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section = null;
    if (target && target.matches && target.matches('[data-ev-product]')) {
      section = target;
    } else if (target && target.querySelector) {
      section = target.querySelector('[data-ev-product]');
    }
    if (!section) return;
    resetProductBindings(section);
    initProductPage(section);
  });
})();
